module.exports = __webpack_public_path__ + "img/oc-logo-with-title.be8518ec.png";